import { render, staticRenderFns } from "./BindUsdt.vue?vue&type=template&id=1d66d0fa&scoped=true&"
import script from "./BindUsdt.vue?vue&type=script&lang=js&"
export * from "./BindUsdt.vue?vue&type=script&lang=js&"
import style0 from "./BindUsdt.vue?vue&type=style&index=0&id=1d66d0fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d66d0fa",
  null
  
)

export default component.exports